import React from 'react';

import { Box } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';

import Footer from './Footer';

const LayoutWrapper = ({ sidebar, content, hasFooter = false, children }) => {
    return (
        <Wrapper>
            {sidebar}

            <MainContent>
                {content}

                {hasFooter && (
                    <Box mt="auto" mb="0">
                        <Footer />
                    </Box>
                )}
            </MainContent>

            {children}
        </Wrapper>
    );
};

const Wrapper = styled.div`
    padding-bottom: 40px;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 80px;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: auto;

    @media (min-width: 769px) {
        overflow-y: initial;
        flex-direction: row;
    }
`;

const MainContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;

    @media (min-width: 769px) {
        overflow-y: auto;
    }
`;

export default LayoutWrapper;
